import { Grid, Typography, debounce, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { setData, setServiceFunction } from "./../../../../store/formSlice";
import FormTextField from "./../../../../Controllers/Input/index";
import service from "./../../helpers/GifService";
import {
  debounceDuration,
  safeValue,
} from "./../../siteMap/navigations/helpers";
import ApplicantSelector from "../../Components/applicantSelector";
import {
  canEditSelector,
  reportingAsSelector,
} from "../../../../store/applicantsSlice";
import { useSelector } from "react-redux";
import { useLoading } from "../../../../providers/loadingProvider";
import InfoDialog from "../ProjectFinancing/InfoDialog";

const pageName = "Major Research Interest";
const fields = {
  intrests: "majorResearchInterest",
};

const Research = (props) => {
  const methods = useForm();
  const dispatch = useDispatch();
  const { setValue, getValues, formState, watch } = methods;
  const loading = useLoading();
  const watchAll = watch();
  const as = useSelector(reportingAsSelector);
  const canEdit = useSelector(canEditSelector);
  const [showInfo, setShowInfo] = useState(false);
  const infoContent =
    "Please provide a brief overview of your main research interests in a few sentences.";

  useEffect(() => {
    dispatch(setServiceFunction(`updateApplicantMajorresearchinterest`));
  }, [dispatch]);

  // set form state in the store
  const debouncedSetData = useMemo(
    () =>
      debounce(() => {
        const dirty = Object.keys(formState.dirtyFields);
        const values = getValues(dirty);
        if (dirty.length === 0) return;
        const fundingToUpdate = {
          majorresearchinterest: values.majorResearchInterest,
        };
        dispatch(setData(fundingToUpdate));
      }, debounceDuration),
    [dispatch, formState.dirtyFields, getValues]
  );
  useEffect(() => {
    const fillApplicantData = async () => {
      const loadingId = loading.addLoading("loading applicant data");
      const applicantData = await service.getContactRishum();
      setValue(fields.intrests, safeValue(applicantData.majorResearchInterest));
      loading.removeLoading(loadingId);
    };
    fillApplicantData();
  }, [setValue, as, loading]);

  useEffect(() => {
    debouncedSetData();
  }, [debouncedSetData, watchAll]);

  return (
    <FormProvider {...methods}>
      <InfoDialog
        open={showInfo}
        onClose={() => setShowInfo(false)}
        content={infoContent}
      ></InfoDialog>
      <form>
        <Grid container spacing={2}>
          <Grid item>
            <Typography variant="subtitle2">{pageName}</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={() => setShowInfo(true)}>
              <InfoOutlinedIcon color="primary" />
            </IconButton>
          </Grid>
          <ApplicantSelector />
          <Grid item xs={12}>
            <FormTextField
              autoFocus
              multiline
              label="Major Research Interest"
              name={fields.intrests}
              disabled={!canEdit}
            />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default Research;
